import type React from "react";

import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";
import {
    StyledHintWrapper,
    StyledHint,
} from "app/pages/sales-intelligence/modules/enrichment/containers/UploadCSVEnrichmentContainer/styles";
import type { EnrichmentType } from "app/pages/sales-intelligence/modules/enrichment/types/types";
import { CONTACTS_QUOTA, QUOTA } from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";

type Props = {
    type: EnrichmentType;
    quota: string;
};

export const CustomHint: React.FC<Props> = ({ type, quota }) => {
    const translateKey = type === "contact" ? CONTACTS_QUOTA : QUOTA;

    return (
        <StyledHintWrapper>
            <SWReactIcons
                iconName="info-full"
                size="xs"
            />
            <StyledHint>
                <div>{translate(translateKey, { quota })}</div>
            </StyledHint>
        </StyledHintWrapper>
    );
};
